import { cart } from 'core';
import { usePaymentMethods } from 'core/use-cases/checkout/hooks';
import { CheckoutSkeleton } from 'ui/components';
import { NotFoundBankSlip } from './BankSlip';
import { PaymentsGroup } from './PaymentsGroup';

const PaymentWrapper = () => {
  const { isError, isLoading: paymentIsLoading, data } = usePaymentMethods();
  const { isLoading: cartIsLoading } = cart.hooks.useCart();
  const isLoading = paymentIsLoading || cartIsLoading;

  if (isError) {
    return <NotFoundBankSlip />;
  }

  if (isLoading) {
    return <CheckoutSkeleton />;
  }

  return <PaymentsGroup {...data} />;
};

export default PaymentWrapper;
